import React from 'react';
import moment from 'moment';
import cronParser from 'cron-parser';
import MonitoringDomainTable from './MonitoringDomainTable';
import CreateMonitoringDomainButton from './CreateMonitoringDomainButton';
import { Tag } from 'antd';

const cron = '0 */6 * * *';

export default function MonitoringDomain() {
  const interval = cronParser.parseExpression(cron);
  const lastUpdate = moment(interval.prev().getTime()).fromNow();
  const nextUpdate = moment(interval.next().getTime()).fromNow();

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ marginBottom: 15 }}>
          <a
            href="https://turing.grafana.net/d/R0bysslnk/email-communication-system-ecs?orgId=1&refresh=10s&var-env=prod&viewPanel=51"
            target="_blank"
          >
            View domain reputation score on grafana
          </a>
        </div>

        <div>
          <Tag>last updated {lastUpdate}</Tag>
          <Tag>next update {nextUpdate} </Tag>
        </div>
      </div>

      <div style={{ marginBottom: 10 }}>
        <div className="flex items-center space-x-2">
          <CreateMonitoringDomainButton />
        </div>
      </div>
      <MonitoringDomainTable />
    </div>
  );
}
